// Runtime config fetched from the Api on bootstrap so a single SPA bundle can
// serve all environments (author/int/ppe/prod). Authoritative source is the
// Api's appsettings / Bicep-injected env vars.
export interface RuntimeConfig {
  clientId: string;
  authority: string;
  apiScope: string;
  environment: string;
  /** When true, render bot/agent Adaptive Cards + suggested actions in live mode (activity-aware
   *  relay). Follows the server's OmnichannelBridge:Enabled setting. */
  richMessages: boolean;
  /** When true, the Microsoft Rewards support page is served (only /en-us/rewards on the contact portal hosts;
   *  /<locale>/rewards and /<locale>/#/rewards elsewhere). Mirrors the peridot.rewards.enabled feature flag. */
  rewardsEnabled: boolean;
  /** When true, the Teams support page is served at /en-us/teams. Mirrors the peridot.teams.enabled feature flag. */
  teamsEnabled: boolean;
  /** Mirrors the contactportal.home.enabled feature flag (off by default). Only consulted on contact portal hosts
   *  (see config/portalRouting.ts): there, when false, every URL redirects to the public support "Contact us" page. */
  contactPortalHomeEnabled: boolean;
  version: string;
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const res = await fetch('/api/v1/config', { method: 'GET' });
  if (!res.ok) {
    throw new Error(`Failed to load runtime config: HTTP ${res.status}`);
  }
  return (await res.json()) as RuntimeConfig;
}
